import type { SortOrder } from 'antd/es/table/interface';

/**
 * Spread onto a date column to put the asc/desc carets next to its title.
 *
 * Sorting is served by the API - SharedTable turns the click into an ABP `sorting` string
 * and the hook re-queries from page one - so the whole result set is re-ordered rather
 * than just the rows currently on screen.
 *
 * Descending first: on a date the first thing anyone wants is newest at the top.
 */
export const dateSorter = {
  sorter: true as const,
  sortDirections: ['descend', 'ascend'] as SortOrder[],
};

const time = (value: unknown) => (value ? new Date(value as string).getTime() : 0);

/**
 * The in-memory counterpart of dateSorter, for the tables that already hold their whole
 * result set (no paging) - antd does the ordering itself, so nothing is asked of the API.
 * Rows with no date sort as the oldest.
 */
export const clientDateSorter = (field: string) => ({
  sorter: (a: any, b: any) => time(a?.[field]) - time(b?.[field]),
  sortDirections: ['descend', 'ascend'] as SortOrder[],
});
